import React, { useRef } from "react";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import BaseScreenProps from "@app/scene/reports/components/BaseScreenProps";
import BaseModalPreviewProps from "@app/scene/reports/components/Overview/components/BaseModalPreviewProps";
import { OnPreview } from "@app/scene/reports/components/Overview/types/onPreview";
import { EntityTypeSupportedInOverviewPreview } from "@app/scene/reports/types/EntityTypeSupportedInOverviewPreview";

import EntityListModal, { ModalRef } from "./index";
import { useEntityListColumns } from "./useEntityListColumns/useEntityListColumns";

interface Props extends BaseScreenProps {
  children: (props: { showModal: () => void }) => React.ReactNode;
  entityType: EntityTypeSupportedInOverviewPreview;
  onModalTableRow?: BaseModalPreviewProps["onRow"];
  onPreview: OnPreview;
}

export const EntityStatCard = ({
  children,
  entityType,
  onModalTableRow,
  onPreview,
  selectedTeams,
  selectedUsers,
}: Props) => {
  const modalRef = useRef<ModalRef>(null);

  const [isModalVisible, showModal, hideModal] = useBoolean();

  const columns = useEntityListColumns(entityType, onPreview);

  return (
    <>
      {children({ showModal })}
      {isModalVisible && (
        <EntityListModal
          columns={columns}
          entityType={entityType}
          key={entityType}
          onHide={hideModal}
          onRow={onModalTableRow}
          ref={modalRef}
          selectedTeams={selectedTeams}
          selectedUsers={selectedUsers}
        />
      )}
    </>
  );
};
